(function () {
  function flashCopied(el) {
    if (!el) return;
    el.classList.add('copied');
    setTimeout(function () {
      el.classList.remove('copied');
    }, 2000);
  }

  function copyToClipboard(url, feedbackEl) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(function () {
          flashCopied(feedbackEl);
        })
        .catch(function (err) {
          console.error(err);
        });
      return;
    }
    // Legacy fallback for browsers without the async clipboard API
    var tmp = document.createElement('textarea');
    tmp.value = url;
    tmp.setAttribute('readonly', '');
    tmp.style.position = 'absolute';
    tmp.style.left = '-9999px';
    document.body.appendChild(tmp);
    tmp.select();
    try {
      document.execCommand('copy');
      flashCopied(feedbackEl);
    } catch (err) {
      console.error(err);
    }
    document.body.removeChild(tmp);
  }

  function initCopyButtons() {
    document.querySelectorAll('.share-button__copy').forEach(function (button) {
      button.addEventListener('click', function () {
        copyToClipboard(button.getAttribute('data-url'), button);
      });
    });
  }

  function initNativeShare() {
    document.querySelectorAll('.share-button__native').forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-share-url');
        var title = button.getAttribute('data-share-title') || document.title;
        // Web Share API where available, otherwise fall back to copying the link
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function (err) {
            if (err && err.name !== 'AbortError') {
              copyToClipboard(url, button);
            }
          });
        } else {
          copyToClipboard(url, button);
        }
      });
    });
  }

  function initSocialWindows() {
    document.querySelectorAll('.social-sharing__link').forEach(function (el) {
      // Messenger uses a native deep link, so let the browser/OS handle it
      if (el.classList.contains('share-messenger')) return;
      el.addEventListener('click', function (event) {
        event.preventDefault();
        var url = el.getAttribute('href');
        var left = (screen.width - 570) / 2;
        var top = (screen.height - 570) / 2;
        var params =
          'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left;
        window.open(url, 'NewWindow', params);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCopyButtons();
    initNativeShare();
    initSocialWindows();
  });
})();
